import {
  Box,
  Grid,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
  Skeleton,
  Button,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { getPlatformLogoSrc } from "../../components/Reports/Components/utils";
import { useProductInsights } from "./dashboardHooks";
import { numberFormatter } from "../../helper/Reports/common";
const userPlatform = JSON.parse(localStorage.getItem("user_platform")) || "amazon";


export default function ProductInsights() {
  const [deficitTab, setDeficitTab] = useState(0);
  const {topPerformers, highPotential, deficitProducts, loadingState} = useProductInsights();


  // Get deficit products based on selected tab
  const deficitProductRows = deficitTab === 0 
    ? deficitProducts.zeroRevenue?.data || []
    : deficitProducts.zeroSpends?.data || [];
  

  const handleViewAll = (type) => {
    let filters = {};
    if (type === "topPerformers") {
       filters = topPerformers?.filters;
    } else if (type === "highPotential") {
      filters = highPotential?.filters;
    } else if (type === "deficitProducts") {
      if (deficitTab === 0) {
        filters = deficitProducts?.zeroRevenue?.filters;
      } else {
        filters = deficitProducts?.zeroSpends?.filters;
      }
    }
    const filtersString = encodeURIComponent(JSON.stringify(filters));
    window.open(`/product-analytics?reportType=product_id&viewtype=PERFORMANCE&urlQuery=${filtersString}`, "_blank");
  };
  return (
    <div>
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          fontSize: "16px",
          mb: 1,
        }}
      >
        Product Insights
      </Typography>

      <Grid container spacing={2} mb={5}>
        {/* ---------- Top Performers ----------- */}
        <Grid item xs={4} sx={{ minWidth: 0, flex: "1 1 0" }}>
          <Paper
            sx={{
              p: 1.5,
              borderRadius: 2,
              boxShadow: "none",
              background: "#FAFAFA",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography fontWeight={600} variant="caption">
                  Top Performers
                </Typography>
                <Tooltip title="Top Performers are the products that have the highest ROAS and Spend in the selected date range.">
                  <IconButton size="small" sx={{ p: 0.5 }}>
                    <InfoOutlinedIcon
                      sx={{ fontSize: 16, color: "text.secondary" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
              <Button
                variant="text"
                size="small"
                endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                onClick={() => handleViewAll("topPerformers")}
              >
                View All
              </Button>
            </Box>

            <TableContainer
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: 2,
                background: "#FFFFFF",
              }}
            >
              <Table
                size="small"
                sx={{
                  borderCollapse: "separate",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                      }}
                    >
                      <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                        Targeting
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "110px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                       <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          Spend
                        </Typography>
                       
                      </Box>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "100px",
                      }}
                    >
                     <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                       <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          ROAS
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Summary row */}
                  <TableRow>
                    <TableCell
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.topPerformers ? <Skeleton width="60px" height={20} /> : "Summary"}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.topPerformers ? <Skeleton width="70px" height={20} /> : numberFormatter(topPerformers?.summary?.totalSpends || 0, true, "number", 0)}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.topPerformers ? <Skeleton width="40px" height={20} /> : numberFormatter(topPerformers?.summary?.avgRoas || 0, false, "number", 1)}
                    </TableCell>
                  </TableRow>

                  {/* Product rows */}
                  {loadingState.topPerformers
                    ? [...Array(5)].map((_, i) => (
                        <TableRow sx={{height: "58px"}} key={`skeleton-${i}`}>
                          <TableCell
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                              }}
                            >
                              <Skeleton
                                variant="rectangular"
                                width={32}
                                height={32}
                                sx={{ borderRadius: "2px" }}
                              />
                              <Skeleton width="80%" height={30} />
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Skeleton width="60px" height={20} />
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Skeleton width="40px" height={20} />
                          </TableCell>
                        </TableRow>
                      ))
                    : (topPerformers?.data || []).map((row, i) => (
                    <TableRow sx={{height: "58px"}} key={i}>
                      <TableCell
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === topPerformers.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          {/* <Box
                            sx={{
                              minWidth: 32,
                              minHeight: 32,
                              bgcolor: "#D9D9D9",
                              borderRadius: "2px",
                            }}
                          /> */}
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "12px",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              lineHeight: 1.4,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === topPerformers.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        {numberFormatter(row?.spend || 0, true, "number", 0)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === topPerformers.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        {numberFormatter(row?.roas || 0, false, "number", 1)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* ---------- High Potential ----------- */}
        <Grid item xs={4} sx={{ minWidth: 0, flex: "1 1 0" }}>
          <Paper
            sx={{
              p: 1.5,
              borderRadius: 2,
              boxShadow: "none",
              background: "#FAFAFA",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography fontWeight={600} variant="caption">
                  High Potential
                </Typography>
                <Tooltip title="High Potential products are the products that have a potential to perform well in the selected date range.">
                  <IconButton size="small" sx={{ p: 0.5 }}>
                    <InfoOutlinedIcon
                      sx={{ fontSize: 16, color: "text.secondary" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
              <Button
                variant="text"
                size="small"
                endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                onClick={() => handleViewAll("highPotential")}
              >
                View All
              </Button>
            </Box>

            <TableContainer
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: 2,
                background: "#FFFFFF",
              }}
            >
              <Table
                size="small"
                sx={{
                  borderCollapse: "separate",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                      }}
                    >
                      <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                        Targeting
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "110px",
                      }}
                    >
                     <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                       <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          Spend
                        </Typography>
                       
                      </Box>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "100px",
                      }}
                    >
                    <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                       <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          ROAS
                        </Typography>
                      
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Summary row */}
                  <TableRow>
                    <TableCell
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.highPotential ? <Skeleton width="60px" height={20} /> : "Summary"}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                        width: "100px",
                      }}
                    >
                      {loadingState.highPotential ? <Skeleton width="70px" height={20} /> : numberFormatter(highPotential?.summary?.totalSpends || 0, true, "number", 0)}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                        width: "100px",
                      }}
                    >
                      {loadingState.highPotential ? <Skeleton width="40px" height={20} /> : numberFormatter(highPotential?.summary?.avgRoas || 0, false, "number", 1)}
                    </TableCell>
                  </TableRow>

                  {/* Product rows */}
                  {loadingState.highPotential
                    ? [...Array(5)].map((_, i) => (
                        <TableRow sx={{height: "58px"}} key={`skeleton-high-potential-${i}`}>
                          <TableCell
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                              }}
                            >
                              <Skeleton
                                variant="rectangular"
                                width={32}
                                height={32}
                                sx={{ borderRadius: "2px" }}
                              />
                              <Skeleton width="80%" height={30} />
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                              width: "100px",
                            }}
                          >
                            <Skeleton width="60px" height={20} />
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 4
                                  ? "none"
                                  : "1px solid #E0E0E0",
                              width: "100px",
                            }}
                          >
                            <Skeleton width="40px" height={20} />
                          </TableCell>
                        </TableRow>
                      ))
                    : (highPotential?.data || []).map((row, i) => (
                    <TableRow sx={{height: "58px"}} key={i}>
                      <TableCell
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === (highPotential?.data || []).length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          {/* <Box
                            sx={{
                              minWidth: 32,
                              minHeight: 32,
                              bgcolor: "#D9D9D9",
                              borderRadius: "2px",
                            }}
                          /> */}
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "12px",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              lineHeight: 1.4,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === topPerformers.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                          width: "100px",
                        }}
                      >
                        {numberFormatter(row?.spend || 0, true, "number", 0)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === topPerformers.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                          width: "100px",
                        }}
                      >
                        {numberFormatter(row?.roas || 0, false, "number", 1)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* ---------- Deficit Products ----------- */}
        <Grid item xs={4} sx={{ minWidth: 0, flex: "1 1 0" }}>
          <Paper
            sx={{
              p: 1.5,
              borderRadius: 2,
              boxShadow: "none",
              background: "#FAFAFA",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography fontWeight={600} variant="caption">
                  Deficit Products
                </Typography>
                <Tooltip title="Deficit Products are the products that have a negative ROAS and Spend in the selected date range.">
                  <IconButton size="small" sx={{ p: 0.5 }}>
                    <InfoOutlinedIcon
                      sx={{ fontSize: 16, color: "text.secondary" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
              <Button
                variant="text"
                endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                size="small"
                onClick={() => handleViewAll("deficitProducts")}
              >
                View All
              </Button>
            </Box>

            {/* Tabs */}
            <Tabs
              value={deficitTab}
              onChange={(e, newValue) => setDeficitTab(newValue)}
              sx={{
                mb: 3,
                mt: 3,
                minHeight: "auto",
                "& .MuiTab-root": {
                  minHeight: "auto",
                  padding: "4px 12px",
                  fontSize: "0.875rem",
                  textTransform: "none",
                  color: "text.secondary",
                  "&.Mui-selected": {
                    color: "#7558ea",
                    fontWeight: 600,
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#7558ea",
                  height: 2,
                },
              }}
            >
              <Tab label="Zero Revenue" />
              <Tab label="Zero Spends" />
            </Tabs>

            <TableContainer
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: 2,
                background: "#FFFFFF",
              }}
            >
              <Table
                size="small"
                sx={{
                  borderCollapse: "separate",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                      }}
                    >
                      <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                        Targeting
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "110px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                       <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          Spend
                        </Typography>
                       
                      </Box>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "8px 12px",
                        fontSize: "12px",
                        color: "text.secondary",
                        fontWeight: 600,
                        width: "100px",
                      }}
                    >
                     <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          gap: 0.5,
                        }}
                      >
                        <img src={getPlatformLogoSrc(userPlatform)} alt={userPlatform} style={{ width: "14px", height: "14px" }} />
                        <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                          Revenue
                        </Typography>
                        
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Summary row */}
                  <TableRow>
                    <TableCell
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.deficitProducts ? <Skeleton width="60px" height={20} /> : "Summary"}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.deficitProducts ? (
                        <Skeleton width="70px" height={20} />
                      ) : (
                        deficitTab === 0
                          ? numberFormatter(deficitProducts?.zeroRevenue?.summary?.totalSpends || 0, true, "number", 0)
                          : numberFormatter(deficitProducts?.zeroSpends?.summary?.totalRevenue || 0, true, "number", 0)
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        bgcolor: "rgb(234, 230, 253)",
                        padding: "8px 12px",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderBottom: "none",
                      }}
                    >
                      {loadingState.deficitProducts ? (
                        <Skeleton width="70px" height={20} />
                      ) : (
                        deficitTab === 0
                          ? numberFormatter(deficitProducts?.zeroRevenue?.summary?.totalRevenue || 0, true, "number", 0)
                          : numberFormatter(deficitProducts?.zeroSpends?.summary?.totalRevenue || 0, true, "number", 0)
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Product rows */}
                  {loadingState.deficitProducts
                    ? [...Array(4)].map((_, i) => (
                        <TableRow sx={{height: "58px"}} key={`skeleton-deficit-${i}`}>
                          <TableCell
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 3
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                              }}
                            >
                              <Skeleton
                                variant="rectangular"
                                width={32}
                                height={32}
                                sx={{ borderRadius: "2px" }}
                              />
                              <Skeleton width="80%" height={30} />
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 3
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Skeleton width="60px" height={20} />
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              padding: "12px 12px",
                              fontSize: "12px",
                              borderBottom:
                                i === 3
                                  ? "none"
                                  : "1px solid #E0E0E0",
                            }}
                          >
                            <Skeleton width="40px" height={20} />
                          </TableCell>
                        </TableRow>
                      ))
                    : deficitProductRows.map((row, i) => (
                    <TableRow sx={{height: "58px"}} key={i}>
                      <TableCell
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === deficitProductRows.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          {/* <Box
                            sx={{
                              minWidth: 32,
                              minHeight: 32,
                              bgcolor: "#D9D9D9",
                              borderRadius: "2px",
                            }}
                          /> */}
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "12px",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              lineHeight: 1.4,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === deficitProductRows.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        {numberFormatter(row?.spend || 0, true, "number", 0)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          padding: "12px 12px",
                          fontSize: "12px",
                          borderBottom:
                            i === deficitProductRows.length - 1
                              ? "none"
                              : "1px solid #E0E0E0",
                        }}
                      >
                        {numberFormatter(row?.revenue || 0, true, "number", 0)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
